import React, { useContext } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import navData from '../languages/navData.json';
import { LanguageContext } from '../context/LanguageContext';
import {
  SideNavAdministrationIcon,
  SideNavAssetCardsIcon,
  SideNavAuditLogsIcon,
  SideNavAutomationsIcon,
  SideNavConfigurationsIcon,
  SideNavDashboardsExanmplesIcon,
  SideNavDashboardsIcon,
  SideNavDevicesIcon,
  SideNavLocationsIcon,
  SideNavOrganizationsIcon,
  SideNavOTAIcon,
  SideNavPermissionsIcon,
  SideNavPlansIcon,
  SideNavRolesIcon,
  SideNavSubscriptionsIcon,
  SideNavTemplatesIcon,
  SideNavUsersIcon,
  UserHealthIcon,
  SideNavAgentDecisionsIcon,
  SideNavEscalationsIcon,
  SideNavPendingApprovalsIcon
} from '../svg/UtilsIcons';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
export function useMainMenu() {
  const { lang } = useContext(LanguageContext);
  const items = navData[lang].menu;

  return items.map(item => ({
    key: item.key,
    title: item.title,
    path: item.path,
    icon: (() => {
      switch (item.key) {
        case 'dashboards': return <SideNavDashboardsIcon />;
        case 'devices': return <SideNavDevicesIcon />;
        case 'assetcards': return <SideNavAssetCardsIcon />;
        case 'notifications': return <NotificationsIcon style={{ width: "28px", height: "28px", viewBox: "0 0 23 22", fill: "currentColor", color: "var(--sidenav-icons, #314C55)" }} />;
        case 'weather': return <WbSunnyOutlinedIcon style={{ width: "28px", height: "28px", fill: "currentColor", color: "var(--sidenav-icons, #314C55)" }} />;
        case 'automations': return <SideNavAutomationsIcon />;
        case 'locations': return <SideNavLocationsIcon />;
        case 'peoplecounter': return <PeopleAltOutlinedIcon style={{ width: "28px", height: "28px", color: "var(--sidenav-icons, #314C55)" }} />;
        case 'administration': return <SideNavAdministrationIcon />;
        case 'configuration': return <SideNavConfigurationsIcon />;
        case 'userhealth': return <UserHealthIcon />;
        case 'contact': return <SideNavLocationsIcon style={{ width: "28px", height: "28px", viewBox: "0 0 23 22", fill: "currentColor", color: "var(--sidenav-icons, #314C55)" }}/>;
        default: return null;
      }
    })(),
    subNav: item.subNav?.map(sub => ({
      key: sub.key,
      title: sub.title,
      path: sub.path,
      icon: (() => {
        switch (sub.key) {
          case 'organizations': return <SideNavOrganizationsIcon />;
          case 'users': return <SideNavUsersIcon />;
          case 'agentdecisions': return <SideNavAgentDecisionsIcon />;
       case 'agent_escalations': return <SideNavEscalationsIcon />;
          case 'agent_pending_approvals': return <SideNavPendingApprovalsIcon />;
           case 'subscriptions': return <SideNavSubscriptionsIcon />;
          case 'plans': return <SideNavPlansIcon />;
          case 'deviceplans': return <SideNavPlansIcon />;
          case 'systemnotifications': return <NotificationsIcon style={{ width: "22px", height: "22px", fill: "currentColor", color: "var(--sidenav-icons, #314C55)" }} />;
          case 'roles': return <SideNavRolesIcon />;
          case 'permissions': return <SideNavPermissionsIcon />;
          case 'auditlogs': return <SideNavAuditLogsIcon />;
          case 'templates': return <SideNavTemplatesIcon />;
          case 'templateexamples': return <SideNavTemplatesIcon />;
          case 'dashboardexamples': return <SideNavDashboardsExanmplesIcon />;
          case 'ota': return <SideNavOTAIcon />;
          case 'systemconfigurations': return <SettingsSuggestIcon style={{ width: "22px", height: "22px", fill: "currentColor", color: "var(--sidenav-icons, #314C55)" }} />;
          case 'peoplecounterdevices': return <StorageOutlinedIcon style={{ width: "22px", height: "22px", color: "var(--sidenav-icons, #314C55)" }} />;
          case 'peoplecounterstatistics': return <QueryStatsOutlinedIcon style={{ width: "22px", height: "22px", color: "var(--sidenav-icons, #314C55)" }} />;
          case 'usershealthdashboard': return <UserHealthIcon />;
          case 'usershealth': return <UserHealthIcon />;
          case 'myhealth': return <UserHealthIcon />;
          case 'medicaldevices': return <UserHealthIcon />;
          default: return null;
        }
      })()
    })) || []
  }));
}
